<template>
  <div class="nav-wrap">
    <div class="header-nav center">
      <div class="img"></div>
      <div class="nav-wrap">
        <div class="nav">
          <template v-for="item in navList">
            <a
              v-if="item.children"
              :class="{
                'about-link': true,
                'router-link-active': isActive(item.children)
              }"
            >
              <span class="box-s">{{ lang === 'zh' ? item.tit : item.enTit }}</span>
              <span class="drop-down" :style="{left: lang === 'en' ? item.enLeft : item.left, width: lang === 'zh' ? item.width : item.enWidth }">
              <span class="arrow"></span>
              <span v-for="(citem, ci) in item.children" @click="toPage(citem.path)" :key="ci" v-show="!citem.hidden">
                {{lang === 'zh' ? citem.tit : citem.enTit}}
              </span>
              <div class="padding-box" />
            </span>
            </a>
            <router-link v-else :to="`${lang === 'en' ? '/us' : ''}${item.path}`">
              {{ lang === 'zh' ? item.tit : item.enTit }}
            </router-link>
          </template>
        </div>

        <div class="search-wrap">
          <input type="text" v-model="searchStr">
          <div class="btn" @click="clickSearch">{{lang === 'zh' ? '搜索' : 'Search'}}</div>
        </div>
      </div>

      <div class="lang-btn" @click="changeLanguage()" v-show="showLangBtn">
        <span :class="{active: lang === 'zh'}">中</span>
        <span class="active">/</span>
        <span :class="{active: lang === 'en'}">EN</span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "HeaderNav",
  data() {
    return {
      showLangBtn: true,
      searchStr: '',
      isAbout: false,
      isNews: false,
      navList: [
        {
          tit: '首页',
          path: '/pc/home',
          enTit: 'Home'
        }, {
          tit: '关于我们',
          enTit: 'About Us',
          enWidth: '122px',
          width: '200px',
          left: '-38px',
          enLeft: '2px',
          children: [
            {
              tit: 'GF60',
              path: '/pc/forum',
              enTit: 'GF60'
            }, {
              tit: '上海金司南金融研究院',
              path: '/pc/about',
              enTit: 'SHJSN'
            }
          ]
        }, {
          tit: '论坛资讯',
          enTit: 'Information',
          width: '100px',
          enWidth: '138px',
          left: '14px',
          enLeft: '5px',
          children: [
            {
              tit: '观点',
              path: '/pc/news/0',
              enTit: 'Viewpoint'
            }, {
              tit: '新闻',
              path: '/pc/news/1',
              enTit: 'News'
            }, {
              path: '/pc/detail',
              hidden: true
            }
          ]
        }, {
          tit: '论坛活动',
          // path: '/pc/activity',
          enTit: 'Events',
          width: '100px',
          enWidth: '100px',
          left: '14px',
          enLeft: '3px',
          children: [
            {
              tit: '专业研讨',
              path: '/pc/activity/seminars',
              enTit: 'Seminar'
            }, {
              tit: '年度峰会',
              path: '/pc/activity/submit',
              enTit: 'Summit'
            }
          ]
        }, {
          tit: '论坛成果',
          // path: '/pc/result',
          enTit: 'Research',
          width: '100px',
          left: '14px',
          enWidth: '100px',
          enLeft: '15px',
          children: [
            {
              tit: '研究报告',
              path: '/pc/result/report',
              enTit: 'Report'
            }, {
              tit: 'GF60期刊',
              path: '/pc/result/journal',
              enTit: 'Journal'
            }
          ]
        },
        {
          tit: '专家委员会',
          path: '/pc/expert',
          enTit: 'Experts'
        },
        {
          tit: '气候友好指数',
          path: '/pc/climate-index',
          enTit: 'Climate Friendly Index'
        }
      ]
    }
  },
  methods: {
    initHeader() {
      this.searchStr = this.$route.query.keywords;
    },
    clickSearch() {
      if(this.searchStr) {
        const path = this.lang === 'zh' ? '/pc/search' : '/us/pc/search';
        this.$router.push(`${path}?keywords=${this.searchStr}`);
      }
    },
    toPage(path) {
      const _path = this.lang === 'zh' ? path : '/us' + path;
      this.$router.push(_path);
    },
    changeLanguage() {
      this.$store.commit('setPLang', this.lang === 'zh' ? 'en' : 'zh');
      sessionStorage.setItem('plang', this.lang);

      document.title = this.$route.meta[this.lang === 'zh' ? 'title' : 'enTit'];

      const {path} = this.$route;

      if(this.lang === 'zh') {
        this.$router.push(path.substr(3));
      } else {
        this.$router.push('/us' + path);
      }

      this.clickSearch();
    },
    isActive(children) {
      const pathList = children.map(item => item.path.substr(4));
      const currentPath = this.$route.path;
      for(let i = 0; i < pathList.length; i++) {
        if(currentPath.indexOf(pathList[i]) >= 0) {
          return true;
        }
      }
      return false;
    }
  },
  watch: {
    '$route': {
      immediate: true,
      deep: true,
      handler(v) {
        const path = v.path;
        if(path.indexOf('/pc/detail') >= 0) {
          this.showLangBtn = false;
        } else if(path.indexOf('/pc/expert') >= 0) {
          const detail = v.query.isDetail;
          this.showLangBtn = detail != 'true';
        } else {
          this.showLangBtn = true;
        }
      }
    }
  },
  computed: {
    isArtDetail() {
      return this.$route.path.indexOf('/pc/detail') >= 0;
    },
    isExpertDetail() {
      const path = this.$route.path;
      const query = this.$route.query.detail;
      return true;
    },
    lang() {
      return this.$store.state.plang;
    }
  },
  created() {
    this.initHeader();
  }
}
</script>

<style lang="less">
.pc-home {
  .nav-wrap {
    position: relative;
    .about-link {
      position: relative;
      cursor: pointer;
      font-size: 1rem;
      .box-s {
        display: inline-block;
        margin-top: -3px;
      }
      .drop-down {
        display: none;
        position: absolute;
        top: 26px;
        z-index: 2;
        span:not(.arrow) {
          color: #fff;
          display: block;
          background: #00000030;
          font-size: 18px;
          text-align: center;
          padding: 5px 0;
          position: relative;
          z-index: 10;
          &:hover {
            color: #037698;
          }
        }
        .arrow {
          display: block;
          width: 0;
          height: 0;
          border: 7px solid transparent;
          border-bottom-color: rgba(0, 0, 0, .05);
          margin: 0 auto;
        }
        .padding-box {
          width: 100%;
          height: 85px;
          position: absolute;
          top: -7px;
          left: 0;
        }
      }
      &:hover {
        .drop-down {
          display: block;
        }
      }
    }
    .lang-btn {
      position: absolute;
      right: 0;
      top: 40px;
      cursor: pointer;
      font-size: 16px;
      color: #868686;
      .active {
        color: #037698;
      }
      * {
        display: inline-block;
        margin: 0 2px;
      }
    }
  }
  .header-nav {
    padding: 30px 0;
    margin: 0 auto;
    position: relative;
    > .img {
      width: 250px;
      height: 60px;
      margin: 0 auto 15px;
      background-image: url("../../assets/logo.jpg");
      background-position: 50% 50%;
      background-size: 250px;
      background-repeat: no-repeat;
    }
    .nav-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .nav {
        font-size: 0;
        * {
          vertical-align: middle;
        }

        a {
          font-size: 22px;
          color: #000;
          text-decoration: none;
          vertical-align: middle;
          & ~ a {
            &:before {
              vertical-align: middle;
              content: "";
              display: inline-block;
              width: 1px;
              height: 22px;
              background: #000;
              margin: -3px 9px 0;
            }
          }

          .txt {
            display: inline-block;
          }
        }

        .router-link-active {
          color: #037698;
        }
      }
      .search-wrap {
        display: flex;

        .btn {
          width: 90px;
          height: 30px;
          background: #037698;
          color: #fff;
          text-align: center;
          line-height: 30px;
          cursor: pointer;
        }
        input {
          width: 200px;
          border: 1px solid #d2d2d2;
          height: 30px;
          outline: none;
          padding: 0 5px;
        }
      }
    }
  }
}
</style>
